export default __webpack_public_path__ + "assets/images/loadingb30c40bac94efd907a209250b4eb139b.gif";